module.exports = __webpack_public_path__ + "img/bodytalk-logo-flat.4249e482.svg";